"use client";

import React, { useState } from "react";
import {
  ListItemButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Avatar,
  alpha
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MobileSecondaryNavigationItemCards from "@/components/header/navigation/mobile/_components/secondary-navigation/mobile-secondary-navigation-item-cards";
import { HeaderNavProps } from "@/components/header/common/types";

type MobileSecondaryNavigationItemsExtProps = {
  secondaryNavItems: HeaderNavProps[];
};

export default function MobileSecondaryNavigationItemsExt(props: MobileSecondaryNavigationItemsExtProps) {
  const { secondaryNavItems } = props;

  const [currentSecondaryNavItem, setCurrentSecondaryNavItem] = useState("");
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (isExpanded) {
      if (expanded === panel) {
        setExpanded(false);
      } else {
        setExpanded(panel);
      }
    } else {
      setExpanded(false);
    }
  };

  const handleItemClick = (d: HeaderNavProps) => {
    const secondary = d.fields.subNavList ?? [];
    const hasSubNav = secondary?.length;

    if (hasSubNav) {
      if (d.sys.id === currentSecondaryNavItem) {
        setCurrentSecondaryNavItem("");
        return;
      }

      setCurrentSecondaryNavItem(d.sys.id);
    } else {
      window.location.href = d.fields.url;
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 999,
        left: 0,
        top: 60,
        pt: "1rem",
        height: "100dvh",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "background.default"
      }}
      data-testid="mobile-secondary-navigation-items-ext"
    >
      <Box>
        {secondaryNavItems.map((item) => (
          <Accordion
            key={item.sys.id}
            expanded={expanded === item.sys.id}
            onChange={handleAccordionChange(item.sys.id)}
            sx={{
              //  marginTop: "0.5rem",
              transition: "0.2s ease",
              position: "relative",
              backgroundColor: "background.default",
              boxShadow: 0,
              "&:before": {
                display: "none"
              },
              "&.Mui-expanded": {
                bgcolor: "action.hover",
                borderRadius: 1,
                "&::after": {
                  content: "\"\"",
                  display: "block",
                  width: 10,
                  height: "100%",
                  backgroundColor: "secondary.main",
                  position: "absolute",
                  top: 0
                }
              }
            }}
          >
            <AccordionSummary
              id={`panel-${item.sys.id}-header`}
              expandIcon={<ExpandMoreIcon sx={{ display: "none" }} />}
              sx={{
                "& .MuiAccordionSummary-content": {
                  margin: "0!important"
                },
                "&:hover": {
                  background: "transparent"
                },
                "&:not(.Mui-expanded)": {
                  paddingBottom: "0.625rem"
                },
                "&.Mui-expanded": {
                  backgroundColor: "action.hover"
                }
              }}
            >
              <ListItemButton
                onClick={() => handleItemClick(item)}
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  pl: "3.3rem",
                  opacity: .8,
                  backgroundColor: "unset",
                  "&:hover, &.Mui-selected": {
                    "& .MuiTypography-root": {
                      fontWeight: "700"
                    },
                    opacity: 1
                  },
                  "&:hover": {
                    backgroundColor: "unset"
                  }
                }}
                data-nav-level="secondary"
                data-nav-label={item.fields.title}
              >
                {item.fields.icon?.fields.file.url && (
                  <Avatar
                    alt={item.fields.title}
                    src={`https://${item.fields.icon?.fields.file.url}`}
                    sx={ (theme) =>({
                      width: 30,
                      height: 30,
                      border: "1px solid",
                      borderColor: alpha(theme.palette.common.black, 0.7)
                    })}
                  />
                )}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" sx={{ pl: 1, fontWeight: "500" }}>{item.fields.title}</Typography>
                </Box>
              </ListItemButton>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "action.hover" }}>
              <MobileSecondaryNavigationItemCards
                tertiaryNavItems={item.fields.subNavList ?? []}
                tertiaryHeaderLearnMoreUrl={item.fields.learnMoreUrl}
                tertiaryHeaderViewAllDestinationsUrl={item.fields.viewAllDestinationsUrl}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
}
